module.exports = __webpack_public_path__ + "line-awesome.8b1290595e57e1d49d95.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/line-awesome/line-awesome.woff?v=1.1.
// module id = ../../../../../src/assets/vendors/base/fonts/line-awesome/line-awesome.woff?v=1.1.
// module chunks = styles